/**
 * Starts Firebase Analytics and Performance once the page has loaded, keeping the SDK off the critical path.
 * Performance still reports the page load: it reads the browser's buffered timing entries.
 */
export const loadFirebaseAfterPageLoad = () => {
    const load = () => import('./firebase');

    if (document.readyState === 'complete') {
        load();
    } else {
        window.addEventListener('load', load, { once: true });
    }
};
